import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/_services/services/loader.service';
import { Subject, delay } from 'rxjs';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: [ './loader.component.css' ],
})
export class LoaderComponent implements OnInit {
  isLoading: boolean = false;

  constructor(
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
      this.listenToLoading();
  }

  /**
   * Funzione che sta in ascolto per attivare i meno il loader.
   */
  listenToLoading(){
    this.loaderService.isLoading
      .pipe(delay(0))
      .subscribe({
        next: (loading) => {
          this.isLoading = loading
        }
      });
  }
}